(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function setFaqState(item, open) {
    const button = qs('.faq-question', item);
    const answer = qs('.faq-answer', item);
    const plus = qs('.faq-plus', item);
    if (!button || !answer) return;

    item.classList.toggle('active', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (plus) plus.textContent = open ? '−' : '+';
    answer.style.maxHeight = open ? `${answer.scrollHeight}px` : '0px';
  }

  function initFaq() {
    qsa('.faq-item').forEach(item => {
      const button = qs('.faq-question', item);
      const answer = qs('.faq-answer', item);
      if (!button || !answer) return;
      button.type = 'button';
      button.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');
      answer.style.maxHeight = item.classList.contains('active') ? `${answer.scrollHeight}px` : '0px';
    });
  }

  function initReveal() {
    const items = qsa('.reveal:not(.visible)');
    if (!items.length) return;
    if ('IntersectionObserver' in window) {
      if (!window.nrRevealObserver) {
        window.nrRevealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              window.nrRevealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.08 });
      }
      items.forEach(el => window.nrRevealObserver.observe(el));
    } else items.forEach(el => el.classList.add('visible'));
  }

  function initMobileMenu() {
    const toggle = qs('#mobileToggle');
    const menu = qs('#mobileMenu');
    if (!toggle || !menu || toggle.dataset.bound === 'true') return;
    toggle.dataset.bound = 'true';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('active');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    qsa('a', menu).forEach(link => link.addEventListener('click', () => {
      menu.classList.remove('active');
      toggle.setAttribute('aria-expanded', 'false');
    }));
  }

  function initWishlist() {
    qsa('.wishlist:not([data-bound])').forEach(button => {
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const active = button.classList.toggle('is-active');
        button.textContent = active ? '♥' : '♡';
      });
    });
  }

  function initQuickAdd() {
    qsa('.quick-add-form:not([data-bound])').forEach(form => {
      form.dataset.bound = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = qs('.quick-add', form);
        const idField = qs('[name="id"]', form);
        if (!idField) return;
        const original = button ? button.textContent : '';
        if (button) { button.disabled = true; button.textContent = 'Adding…'; }
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({ id: Number(idField.value), quantity: Number((qs('[name="quantity"]', form) || {}).value || 1) })
          });
          if (!response.ok) throw new Error('Add failed');
          const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then(r => r.json());
          qsa('.cart-count').forEach(el => el.textContent = cart.item_count);
          if (button) button.textContent = 'Added ✓';
          setTimeout(() => { if (button) { button.textContent = original; button.disabled = false; } }, 1200);
        } catch (error) {
          if (button) { button.textContent = 'Try Again'; button.disabled = false; }
        }
      });
    });
  }


  function initProductGallery() {
    const main = document.getElementById('product-main-image');
    if (!main) return;
    qsa('[data-product-image]:not([data-gallery-bound])').forEach(button => {
      button.dataset.galleryBound = 'true';
      button.addEventListener('click', () => {
        const image = button.dataset.productImage;
        if (!image) return;
        main.src = image;
        main.alt = button.dataset.productAlt || main.alt;
        qsa('[data-product-image]').forEach(item => item.classList.remove('active'));
        button.classList.add('active');
      });
    });
  }

  function initAll() {
    initMobileMenu();
    initFaq();
    initReveal();
    initWishlist();
    initQuickAdd();
    initProductGallery();
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('.faq-question');
    if (!button) return;
    const item = button.closest('.faq-item');
    if (!item) return;
    event.preventDefault();
    const shouldOpen = !item.classList.contains('active');
    qsa('.faq-item').forEach(other => setFaqState(other, other === item && shouldOpen));
  });

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
  document.addEventListener('shopify:block:select', initAll);
  window.addEventListener('resize', () => qsa('.faq-item.active .faq-answer').forEach(answer => { answer.style.maxHeight = `${answer.scrollHeight}px`; }));
})();

/* Cart quantity controls */
document.addEventListener('click', function(e){
  const minus=e.target.closest('[data-cart-minus]');
  const plus=e.target.closest('[data-cart-plus]');
  if(!minus && !plus) return;
  const index=(minus||plus).getAttribute(minus?'data-cart-minus':'data-cart-plus');
  const input=document.querySelector('[data-cart-qty="'+index+'"]');
  if(!input) return;
  const current=parseInt(input.value||1,10);
  input.value=Math.max(0,current+(plus?1:-1));
});
